module.exports = __webpack_public_path__ + "static/media/pho-logo.8f68c9b6.png";